// Angular imports
import { HttpClient } from '@angular/common/http';
// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';
import { map } from 'rxjs/operators';
// Service imports
import { MPCacheRegistrationService } from '../../_services/shared-services/mp-cache-registration-service';
import { WorkflowVendorEditResultDto } from '../_models/workflow-vendor-edit/workflow-vendor-edit-result-dto';
import { WorkflowVendorEditRawDto } from '../_models/workflow-vendor-edit/workflow-vendor-edit-raw-dto';
// constant imports
import { URLConstants } from '../../_constants/url-constants';
import { CacheDuration } from '../../_constants/cache-duration';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../_services/shared-services/mp-cache-registration-service";
export class WorkflowVendorEditService {
    constructor(httpClient, cacheRegistrationService) {
        this.httpClient = httpClient;
        this.cacheRegistrationService = cacheRegistrationService;
    }
    getVendorEditQueue(baseParams) {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}vendoredit/queue${baseParams.getQueryParams()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(WorkflowVendorEditResultDto, response)));
    }
    getWorkflowVendorEdit(baseParams) {
        const url = `${URLConstants.ccWorkflowEditorBaseApiUrl}vendoredit/editor${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(WorkflowVendorEditRawDto, response)));
    }
    saveAndReturnVendor(baseParam) {
        return this.httpClient
            .put(`${URLConstants.ccWorkflowEditorBaseApiUrl}vendoredit/returnstatus`, classToPlain(baseParam))
            .pipe(map((responseData) => responseData));
    }
}
WorkflowVendorEditService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WorkflowVendorEditService_Factory() { return new WorkflowVendorEditService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MPCacheRegistrationService)); }, token: WorkflowVendorEditService, providedIn: "root" });
